/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetUsersForRole = require('common/services/GetUsersForRole');

var GetAllApplicationLookups = require('../../common/services/GetAllApplicationLookups');
var GetOrganizationDetails = require('../services/GetOrganizationDetails');
var SecRegistrationNewView = require('../views/SecRegistrationNewView');

module.exports = function(organizationId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetOrganizationDetails(organizationId), GetUsersForRole('SC - Filing Examiner'), GetAllApplicationLookups())
    .done(function(identifiers, examiners, lookups) {
      NavUtils.navigate('#sec/organization/' + organizationId + '/new-registration');
      Scaffold.content.show(
        new SecRegistrationNewView({
          model: new Backbone.Model({
            organizationId: organizationId,
            identifiers: identifiers,
            examiners: examiners,
            licenseTypes: lookups.applicationLicenseTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
